import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { andrisEmail } from '../fun/andrisEmail'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getPersonName } from '../fun/getPersonName'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { isDead } from '../fun/isDead'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_COPY } from '../icon/ICON_COPY'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { _ } from '../model/ccc'
import { PortraitComp } from './PortraitComp'

export const PageEmailsComp = defineComponent<{}>(
	'PageEmailsComp',
	(props, $) => {
		setPageTitle(`Email címek`)

		const data = getDataOrThrow()

		function getAllPeopleWithEmails() {
			return Object.values(data.personsById).filter(
				(it) => it.email && !isDead(data, it),
			)
		}

		return (
			<div class={_.ccc_page}>
				<h1>Email címek</h1>
				<div class={_.ccc_tiles__centered}>
					<button
						class={_.ccc_button__rounded}
						onclick={() => {
							const text = getAllPeopleWithEmails()
								.map((it) => `${getPersonName(it)} <${it.email}>`)
								.join('; ')
							navigator.clipboard.writeText(text)
						}}
					>
						<Icon svg={ICON_COPY} /> Összes másolása
					</button>
				</div>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Email címek'
						each={getAllPeopleWithEmails}
						render={({ get }) => (
							<a
								class={_.ccc_button__person}
								href={() => url`mailto:${get().email}`}
							>
								<PortraitComp getPerson={get} />
								<div>
									<Slot get={() => getPersonNameFormatted(data, get())} />{' '}
									<div class={_.ccc_email}>
										<Slot get={() => get().email} />
									</div>
								</div>
							</a>
						)}
					/>
					<a
						class={_.ccc_button__plus}
						href={andrisEmail(
							`Új email cím`,
							`És szeretném, ha ez email címem ezen az oldalon szerepelne.`,
						)}
					>
						<Icon svg={ICON_PLUS} /> email
					</a>
				</div>
			</div>
		)
	},
)
